import { MenuItem, TextField, Typography } from "@mui/material";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useGetUsers } from "../../../services/usersApi";

export const UserSelect = (props) => {
    const { label, selectedUserId, setSelectedUserId, disabled = false, excludeUserIds } = props;
    const { t } = useTranslation();
    const { data: users, isLoading } = useGetUsers({}, new URLSearchParams("page_size=9999")); // Skip pagination

    const filteredUsers = useMemo(
        () => users?.results.filter((user) => !excludeUserIds?.includes(user.id)) || [],
        [users, excludeUserIds],
    );

    if (!isLoading && filteredUsers.length === 0) {
        return <Typography>{t("users.noUsersAvailable")}</Typography>;
    }

    return (
        <TextField
            select
            label={label}
            fullWidth
            value={selectedUserId}
            onChange={(e) => setSelectedUserId(e.target.value)}
            disabled={disabled || isLoading}
            SelectProps={{
                sx: { textAlign: "left" },
            }}
        >
            {filteredUsers.map((user) => (
                <MenuItem key={user.id} value={user.id}>
                    {user.full_name}
                </MenuItem>
            ))}
        </TextField>
    );
};
